// Qrcord 顯示
import React, { Component } from 'react';
import { QRCode } from 'react-qrcode-logo';
import qrcodeLogo from '../images/qrcode_logo.png';
import '../scss/components/qrcord_card.scss';
import html2canvas from 'html2canvas';

class QrcordBlock extends Component {
  constructor(props) {
    super(props);
    this.state={}
    this.downloadCanvas = this.downloadCanvas.bind(this);
  }

  downloadCanvas(canvas, filename) {
    /// create an "off-screen" anchor tag
    let lnk = document.createElement('a'), e;
  
    /// the key here is to set the download attribute of the a tag
    lnk.download = filename;
  
    /// convert canvas content to data-uri for link. When download
    /// attribute is set the content pointed to by link will be
    /// pushed as "download" in HTML5 capable browsers
    lnk.href = canvas.toDataURL("image/png;base64");
  
    /// create a "fake" click-event to trigger the download
    if (document.createEvent) {
      e = document.createEvent("MouseEvents");
      e.initMouseEvent("click", true, true, window,
                       0, 0, 0, 0, 0, false, false, false,
                       false, 0, null);
  
      lnk.dispatchEvent(e);
    } else if (lnk.fireEvent) {
      lnk.fireEvent("onclick");
    }
  }

  render() {
    let { isVisible, toggleOpen, QrcordName, QrcordText, QrcordJobType } = this.props;
    if (!isVisible) {
      return null;
    }
    return (
      <div className="u-editblock" onClick={toggleOpen} style={{minHeight:'772px'}}>
        <div className="qrcord-card bounceIn" onClick={(e)=>{e.stopPropagation();}}>
          <div className="card-inner" id="qrcord-card">
            <div className="card-name">{QrcordName}</div>
            <div className="card-jobType">{QrcordJobType}</div>
            <div className="u-qrcode">
              <QRCode
                value={QrcordText} 
                size={160} 
                padding={0} 
                logoImage={qrcodeLogo}
              />
            </div>
          </div>
          <div className="u-btn-group right">
            <button className="btn btn-sm save" onClick={()=>{
              html2canvas(document.querySelector("#qrcord-card")).then(canvas => {
                this.downloadCanvas(canvas, QrcordName);
              });
            }}>下載</button>
            <button className="btn btn-sm cancel m-l-16" onClick={
              (e) => {
                e.preventDefault();
                toggleOpen();
              }
            }>取消</button>
          </div>
        </div>
      </div>
    )
  }
}

export default QrcordBlock;